import {Component, OnDestroy} from '@angular/core';

@Component({
    selector: 'app-on-boarding',
    templateUrl: './on-boarding.component.html',
    styleUrls: ['./on-boarding.component.css'],
    standalone: false
})
export class OnBoardingComponent implements OnDestroy {

    constructor() {
        window.addEventListener('beforeunload', this.setBeforeunloadPopup);
    }

    ngOnDestroy(): void {
        window.removeEventListener('beforeunload', this.setBeforeunloadPopup);
    }

    private setBeforeunloadPopup(event) {
        event.preventDefault();
        event.returnValue = 'Unsaved modifications';
        return event;
    }

}
